import { render, staticRenderFns } from "./EditRoomTemplate.vue?vue&type=template&id=abc35892"
import script from "./EditRoomTemplate.vue?vue&type=script&lang=js"
export * from "./EditRoomTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports